export const SET_TEMP_STATE = '@@form/SET_TEMP_STATE';

export const setTempState = (form, state) => ({
  type: SET_TEMP_STATE,
  form,
  state,
});
